let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("l4YAS")).then(() => parcelRequire('f2ref'));